import { useState } from 'react'
import { useNavigate } from 'react-router-dom'
import IMG_1 from 'assets/images/customer/customer-header-banner-pc.png'
import IMG_2 from 'assets/images/customer/customer-header-banner-mobile.png'
import IMG_3 from 'assets/images/customer/mail.png'
import { BOARD_GO_STATION_INFO } from 'assets/json/boardGoStationInfo.js'
import { BOARD_NOTICE_INFO } from 'assets/json/boardNoticeInfo.js'
import { URL } from '../../utils/Utils'
import CustomerTitle from './components/CustomerTitle'
import MailSendPopup from './MailSendPopup'
import './CustomerMain.scss'

/**
 * @file 고객지원 main 화면
 */
function CustomerMain() {
    return (
        <div>
            <header className="customer-header-wrap">
                <a className="customer-header-title" href={URL.CUSTOMER.CUSTOMER_CENTER}>
                    고객센터
                </a>
                <a className="customer-header-title" href={URL.CUSTOMER.EG_CARE}>
                    EG CARE
                </a>
                <a className="customer-header-title" href={URL.CUSTOMER.DOWNLOAD}>
                    자료실
                </a>
                {/* 230621 서비스망이 갖춰진 이후 서비스네트워크 메뉴는  수정 후 오픈 예정 */}
                <a className="customer-header-title" href={URL.CUSTOMER.SERVICE_NETWORK}>
                    서비스 네트워크
                </a>
                <a className="customer-header-title-blue" href={URL.CUSTOMER.DOWNLOAD_CENTER}>
                    다운로드 센터
                </a>
            </header>
            <img src={IMG_1} className="customer-header-banner-img pc" alt="배너이미지" />
            <img src={IMG_2} className="customer-header-banner-img mobile" alt="배너이미지" />
        </div>
    )
}

export default CustomerMain
